export type AppLocale = "ru" | "en" | "kk";

type LocalizedMap = {
  ru: string;
  en: string;
  kk?: string;
};

const RU_PREFIX = "ru";
const KK_PREFIX = "kk";

export function getAppLocale(): AppLocale {
  if (typeof window === "undefined") {
    return "ru";
  }

  const storedLocale =
    window.localStorage.getItem("app-locale") ||
    window.localStorage.getItem("locale") ||
    window.localStorage.getItem("lang") ||
    document.documentElement.lang ||
    window.navigator.language ||
    "ru";

  const normalized = storedLocale.toLowerCase();
  if (normalized.startsWith(RU_PREFIX)) {
    return "ru";
  }
  if (normalized.startsWith(KK_PREFIX) || normalized.startsWith("kz")) {
    return "kk";
  }
  return "en";
}

export function tLocalized(map: LocalizedMap): string {
  const locale = getAppLocale();
  if (locale === "ru") {
    return map.ru;
  }
  if (locale === "kk") {
    return map.kk || map.ru || map.en;
  }
  return map.en || map.ru;
}

export function resolveLocalizedMap(
  value?: Partial<LocalizedMap> | null,
  fallback = ""
): string {
  if (!value) {
    return fallback;
  }

  const locale = getAppLocale();
  return (
    value[locale] ||
    value.ru ||
    value.en ||
    value.kk ||
    fallback
  );
}

export function resolveLocalizedText(value?: string | null): string {
  if (!value) {
    return "";
  }

  try {
    const parsed = JSON.parse(value);

    if (parsed && typeof parsed === "object" && ("ru" in parsed || "en" in parsed || "kk" in parsed)) {
      return tLocalized({
        ru: parsed.ru ?? parsed.en ?? parsed.kk ?? "",
        en: parsed.en ?? parsed.ru ?? parsed.kk ?? "",
        kk: parsed.kk ?? parsed.ru ?? parsed.en ?? "",
      });
    }
  } catch (error) {
    return value;
  }

  return value;
}
